import * as React from 'react';
import { PublishRequest } from 'records/PublishRequest';
import AppStoreContext from 'contexts/AppStoreContext';
import { ModalState } from 'records/ModalState';
import PubReqViewerModal from 'components/modals/PubReqViewerModal';
import { getPageThumbnailUrl } from 'services/pageService';

type Props = {
  publishRequest: PublishRequest;
};

const AuditListRowTile: React.FC<Props> = React.memo((props: Props) => {
  const { publishRequest } = props;
  const { pageid: pageId, documentid: documentId } = publishRequest;

  const tileRef = React.useRef(null);
  const [pageThumbnailUrl, setPageThumbnailUrl] = React.useState<
    string | undefined
  >(undefined);
  const { actions } = React.useContext(AppStoreContext);

  const handleClick = React.useCallback(() => {
    const modalState = new ModalState({
      id: 'pubReqViewerModal',
      portal: 'main',
      open: true,
      component: PubReqViewerModal,
      props: {
        pageId,
        documentId,
      },
    });

    actions.createModal(modalState);
  }, [pageId, documentId]);

  React.useEffect(() => {
    getPageThumbnailUrl(documentId, pageId)
      .then((url) => {
        setPageThumbnailUrl(url);
      })
      .catch((e: Error) => {
        console.error(
          'error occurred while attempting to fetch page thumbnail url',
          e
        );
      });
  }, [pageId, documentId]);

  return (
    <div ref={tileRef} className="hs3" onClick={handleClick}>
      {pageThumbnailUrl ? (
        <div className="flex-center">
          <img
            alt={publishRequest.sheettitle}
            className="b-2 hs3 of-contain cursor-pointer"
            src={pageThumbnailUrl}
          />
        </div>
      ) : null}
    </div>
  );
});

AuditListRowTile.displayName = 'AuditListRowTileFunc';

export default AuditListRowTile;
